import { Box, Grid, Image, ResponsiveContext, Text } from "grommet";
import { flatten, groupBy } from "lodash";
import * as React from "react";
import { useParams } from "react-router-dom";
import { usePermission } from "../account/AccountStore";
import { AliasCard } from "../aliases/AliasCard";
import { AliasRow } from "../aliases/AliasTable";
import SkeletonWrapper from "../components/SkeletonWrapper";
import { getMatch, MatchStatViewModel, MatchViewModel } from "../matches/MatchesStore";
import { MatchRow } from "../matches/MatchRow";
import { Outcome } from "../matches/OutcomeIcon";
import { StatIcon } from "../stats/StatIcon";
import { TeamName, TeamNameLogo, TeamNameLogoWrapper } from "../teams/TeamName";
import { TeamRow } from "../teams/TeamsManagement";
import { getTeam, TeamViewModel } from "../teams/TeamsStore";
import TeamHeader from "./TeamHeader";

const UXMatchHome = () => {
    let { id } = useParams<{ id: string }>();

    const [match, setMatch] = React.useState(new MatchViewModel());
    const [teams, setTeams] = React.useState([] as TeamViewModel[]);

    const [stats, setStats] = React.useState(null as any);
    const [loading, setLoading] = React.useState(true);
    React.useEffect(() => {
        getMatch(id).then((match) => {
            setMatch(match);
            console.log("interactive");
            setLoading(false);
            setAllScoresZero(match.participants.every((participant) => participant.outcomes.every((outcome) => outcome.score == 0)));

            Promise.all(match.participants.map((participant) => getTeam(participant.teamID))).then((teams) => setTeams(teams.map((t) => t.data.result)));
        });
    }, [id]);

    const [allScoresZero, setAllScoresZero] = React.useState(true);

    const size = React.useContext(ResponsiveContext);

    const hasManagementPermission = usePermission("management");

    return (
        <Box align="center">
            <SkeletonWrapper loading={loading}>
                <Box width={{ max: "xxlarge", min: size }} fill gap="small">
                    <MatchRow match={match} />
                    <Grid columns={size == "small" ? ["auto"] : ["1fr", "2fr"]} gap="small">
                        <Box>{match.logoUri && <Image src={match.logoUri} style={{ maxHeight: "364px", objectFit: "contain" }} />}</Box>
                        <Box gap="small">
                            {match.participants.map((participant, index) => (
                                <Box key={"mp." + index}>
                                    <TeamRow team={participant.team} key={index}>
                                        <Box direction="row" gap="small">
                                            {participant.outcomes.map((outcome, outcomeIndex) => (
                                                <Box direction={"row"} gap="small" key={outcome.id}>
                                                    {!allScoresZero && (
                                                        <Box direction={"row"} background={"background-front"} pad="small" gap="small" round="10px" align="center">
                                                            <Text>Score {outcome.score}</Text>
                                                        </Box>
                                                    )}
                                                    <Outcome outcome={outcome} includeText={true} disabled={false}></Outcome>
                                                </Box>
                                            ))}
                                            {participant.outcomes.length == 0 && <Text color={"background-front"}>Not yet played</Text>}
                                        </Box>
                                    </TeamRow>
                                    <Box background={"background"} direction="row" justify="center">
                                        {match.stats.map((s) => (
                                            <Box key={"mp." + index + "." + s.statID} pad="small" justify="center" background={"background"} round="5px">
                                                <Text size="xlarge">
                                                    {s.teams.filter((t) => t.teamID == participant.teamID)[0]?.value || "0"} {StatIcon(s.stat)}
                                                </Text>
                                                <Text>{s.stat.name}</Text>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Box pad={{ vertical: "small" }}>
                        {teams.length == 2 && match.participants.length == 2 && (
                            <>
                                <Grid columns={{ size: "auto", count: 2 }} gap="small" fill>
                                    <Box fill gap="small">
                                        <Box pad="small" round="5px" background={"background"}>
                                            <TeamNameLogo reverse={false} team={teams[0]} useTeamColor={true}></TeamNameLogo>
                                        </Box>
                                        <Box pad={{ top: "small" }} gap="small" fill direction="row" wrap>
                                            {teams[0].teamMemberships.map((membership) => (
                                                <AliasCard key={membership.id} alias={membership.alias} width={150}></AliasCard>
                                            ))}
                                        </Box>
                                    </Box>
                                    {/* <Grid columns={{ size: "auto", count: 2 }} gap="small">
                                    <Box gap="small" fill="horizontal">
                                        {match.stats.map((s) => (
                                            <Box key={teams[0].id} pad="small" justify="center" background={"background"} round="5px" align="start">
                                                <Text size="xlarge">
                                                    {s.teams.filter((t) => t.teamID == teams[0].id)[0]?.value || "0"} {StatIcon(s.stat)}
                                                </Text>
                                                <Text>{s.stat.name}</Text>
                                            </Box>
                                        ))}
                                    </Box>
                                    <Box gap="small" fill="horizontal">
                                        {match.stats.map((s) => (
                                            <Box key={teams[1].id} pad="small" justify="center" background={"background"} round="5px" align="end">
                                                <Text size="xlarge">
                                                    {s.teams.filter((t) => t.teamID == teams[1].id)[0]?.value} {StatIcon(s.stat)}
                                                </Text>
                                                <Text>{s.stat.name}</Text>
                                            </Box>
                                        ))}
                                    </Box>
                                </Grid> */}
                                    <Box fill gap="small">
                                        <Box align="end" pad="small" round="5px" background={"background"}>
                                            <TeamNameLogo reverse={true} team={teams[1]} useTeamColor={true}></TeamNameLogo>
                                        </Box>
                                        <Box pad={{ top: "small" }} gap="small" fill direction="row" wrap justify="end">
                                            {teams[1].teamMemberships.map((membership) => (
                                                <AliasCard key={membership.id} alias={membership.alias} width={150}></AliasCard>
                                            ))}
                                        </Box>
                                    </Box>
                                </Grid>
                            </>
                        )}
                    </Box>
                </Box>
            </SkeletonWrapper>
        </Box>
    );
};

export default UXMatchHome;
